// Re-enganche del modal de Importación Masiva (ref. BDSJEA-364): helpers puros
// para decidir si hay una corrida viva en el servidor. Se evalúa SIEMPRE el
// JSON crudo de GET /estado (no el resuelto por `resolverEstado`, que convierte
// SIN_CORRIDAS y el final de la corrida previa en INICIANDO).
import { ESTADO } from "./migracionEstadoHelpers"

// Estados en los que el modal se re-engancha. SIN_RESPUESTA y SIN_ARRANQUE son
// "dudosos" (el backend ya aplicó sus umbrales) pero igual se re-engancha para
// mostrar el motivo y se bloquea "Iniciar": el guardián real es el 409 del
// servicio de migración.
export const ESTADOS_CORRIDA_VIVA = [
  ESTADO.EN_CURSO,
  ESTADO.INICIANDO,
  ESTADO.SIN_RESPUESTA,
  ESTADO.SIN_ARRANQUE,
]

export const esCorridaViva = estadoEfectivo =>
  ESTADOS_CORRIDA_VIVA.includes(estadoEfectivo)

/** Devuelve el JSON crudo de /estado si describe una corrida viva; si no, null. */
export const corridaVivaDe = data =>
  data && typeof data === "object" && esCorridaViva(data.estadoEfectivo)
    ? data
    : null
